export default __webpack_public_path__ + "static/bg_1-1afd192c3a953dd2f7443bcd31464dce.png";